import { supabase } from '@/lib/supabase'
import type { ContactLog } from '@/types/domain'

export const contactLogRepo = {
  async findByCustomer(customerId: string): Promise<ContactLog[]> {
    const { data, error } = await supabase
      .from('contact_log')
      .select('*')
      .eq('customer_id', customerId)
      .order('contact_date', { ascending: false })

    if (error) throw error
    return (data || []) as ContactLog[]
  },

  async create(log: any): Promise<ContactLog> {
    const { data: { user } } = await supabase.auth.getUser()

    const { data, error } = await supabase
      .from('contact_log')
      .insert({ ...log, created_by: user?.id } as any)
      .select()
      .single()

    if (error) throw error
    return data as ContactLog
  },

  async update(id: string, updates: any): Promise<ContactLog> {
    const { data, error } = await supabase
      .from('contact_log')
      .update(updates as never)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data as ContactLog
  },

  async delete(id: string): Promise<void> {
    console.log('Attempting to delete contact log:', id)

    const { error } = await supabase
      .from('contact_log')
      .delete()
      .eq('id', id)

    if (error) {
      console.error('Delete contact log error details:', {
        message: error.message,
        details: error.details,
        hint: error.hint,
        code: error.code,
      })
      throw new Error(`Failed to delete contact log: ${error.message}${error.hint ? ` (${error.hint})` : ''}`)
    }

    console.log('Contact log deleted successfully')
  },
}
